import PropTypes from 'prop-types';
import React from 'react';

import { Box, Flex } from '../grid';
import { InputList } from '../input-list';
import { P, Subheading } from '../typography/new';

const StylePicker = ({ title, required, hasError, showTitle, px, borderRadius, ...listProps }) => (
  <Box px={px}>
    <Flex justifyContent="space-between" alignItems="flex-end">
      {showTitle ? <Subheading variant="standard">{title}</Subheading> : null}
      {required && (
        <P color={hasError ? 'redPrimary' : 'greyPrimary'} variant="small">
          Required
        </P>
      )}
    </Flex>
    <InputList {...listProps} borderBottomWidth="0px" borderRadius={borderRadius} />
  </Box>
);

StylePicker.propTypes = {
  title: PropTypes.string.isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  showTitle: PropTypes.bool,
  px: PropTypes.string,
  borderRadius: PropTypes.string,
};

StylePicker.defaultProps = {
  required: false,
  hasError: false,
  showTitle: true,
  px: '1.5rem',
  borderRadius: '50%',
};

export { StylePicker };
